import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { validate as isUuid } from 'uuid';

interface TimesheetStore {
  synced: boolean;
}

export type TimesheetsStore = Record<string, TimesheetStore>;

const initialState: TimesheetsStore = {};

const timesheetsSlice = createSlice({
  name: 'timesheets',
  initialState,
  reducers: {
    setSyncStatus(state, action: PayloadAction<{ timesheetId: string; synced: boolean }>) {
      const { timesheetId, synced } = action.payload;
      // Protect against prototype pollution
      if (!isUuid(timesheetId)) return;
      if (state[timesheetId]) {
        state[timesheetId].synced = synced;
      } else {
        state[timesheetId] = { synced };
      }
    },
  },
});

export const { setSyncStatus } = timesheetsSlice.actions;
export default timesheetsSlice.reducer;
